import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import path from 'path';
const isServer = typeof window === 'undefined';
const localePath = isServer? path.resolve('./public/locales') : '/locales';


i18n
    // Use a different backend for loading translations
    .use(resourcesToBackend((language: string, namespace: string) =>
        // Dynamically import translation files based on language and namespace
        import(`../../../../${localePath}/${language}/${namespace}.json`)
    ))
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        ns: ['common'],
        defaultNS: 'common',
        fallbackLng: 'en-US',
        debug: false, //set to true to debug what is happening
        interpolation: {
            escapeValue: false,
        },
        // A list of supported languages
        supportedLngs: ['en', 'en-US', 'fr', 'fr-CA'],
        // Use the backend cache for faster loading
        backend: {
            // Use the filesystem on the server, but allow http on the client
            loadPath: localePath + '/{{lng}}/{{ns}}.json',
        },
    });

export default i18n;
